module.exports = require('./lib/bootstrap.loader!./no-op.js');



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-loader/loader.js
// module id = 192
// module chunks = 18 20